import moment from 'moment';
import numeral from 'numeral';
import numeralRussianLocale from 'numeral/locales/ru';
import has from 'lodash/has';
import find from 'lodash/find';
import capitalize from 'lodash/capitalize';
import uppercase from 'lodash/upperCase';
import lowercase from 'lodash/lowerCase';
import hash from 'object-hash';

export default class EverydayFiltersPlugin {
    static install(Vue: any) {
        EverydayFiltersPlugin.setupNumeral();
        Vue.mixin({
            methods: {
                log() {
                    console.log(...arguments);
                },
                /**
                 * Проверяет имеет ли объект указанное свойство
                 * @param object
                 * @param path
                 * @return {boolean}
                 */
                has(object, path = null) {
                    return has(object, path);
                },

                find() {
                    return find(...arguments);
                },

                hash() {
                    return hash(...arguments);
                }
            },
            filters: {
                /**
                 * Строка с заглавной буквы
                 * @param value
                 * @return {string}
                 */
                capitalize(value) {
                    return capitalize(value);
                },

                /**
                 * Строка в верхний регистр
                 * @param value
                 * @return {string}
                 */
                uppercase(value) {
                    return uppercase(value);
                },

                /**
                 * Строка в нижний регистр
                 * @param value
                 * @return {string}
                 */
                lowercase(value) {
                    return lowercase(value);
                },

                /**
                 * Добавить к строке запятую если она не пустая
                 * @param value
                 * @return {*}
                 */
                comma(value) {
                    typeof value === 'string'
                    && value.length > 0
                    && (value += ', ');
                    return value;
                },

                /**
                 * Обрезает строку и добавляет постфикс
                 * @param {string} value
                 * @param {numeral} length
                 * @param {string} postfix
                 * @returns {string}
                 */
                truncate(value, length = 10, postfix = '...') {
                    return value.substr(0, length) + postfix;
                },

                /**
                 * Форматируем числа в еданый формат
                 * @param num
                 * @param {string} format
                 * @returns {string|number}
                 */
                formatNum(num, format = '0,0[.]00') {
                    switch (format) {
                        case 'ceil':
                            return Math.ceil(parseFloat(num));
                        case '$':
                            return numeral(parseFloat(num)).format('0,0[.]00$');
                        default:
                            return numeral(parseFloat(num)).format(format);
                    }

                },

                /**
                 * Форматируем дату в нужный вид
                 * @param date
                 * @param format
                 * @returns {*|moment.Moment}
                 */
                formatDate(date: string, format = 'DD.MM.YYYY') {
                    return moment(date).format(format);
                },

                /**
                 * Функция предназначена для склонения слов
                 * используемых вместе с числительными.
                 * @param number
                 * @param one
                 * @param two
                 * @param five
                 * @return string
                 */
                transChoose: function (number: number, one = null, two = null, five = null) {
                    if (typeof one === 'string' && typeof two === 'string' && typeof five === 'string') {
                        let n = Math.abs(number);
                        n %= 100;
                        if (n >= 5 && n <= 20) {
                            return five;
                        }
                        n %= 10;
                        if (n === 1) {
                            return one;
                        }
                        if (n >= 2 && n <= 4) {
                            return two;
                        }
                        return five;
                    }
                    return '';

                },

                /**
                 * Если переменная не задана вернуть значение по умолчанию
                 * @param value
                 * @param defaultValue
                 * @return {*}
                 */
                defaultValue(value: string, defaultValue) {
                    return value === undefined || value === null ? defaultValue : value;
                }
            }
        });
    }

    static setupNumeral() {
        const value: NumeralJSLocale = {
            ...numeralRussianLocale,
            currency: {
                symbol: String.fromCharCode(8381)
            }
        };
        numeral.register('locale', 'russian', value);
        numeral.locale('russian');
    }
}